import { required, minLength } from 'vuelidate/lib/validators'

export const validateData = {
  form: {
    pesquisas: { required, minLength: minLength(1) },
    // quantidadeDigitos: { required, numeric, minValue: minValue(1), maxLength: maxLength(2) },
    // tempoEspera: { required, numeric },
    // quantidadeLoops: { required, numeric },
    // audioPesquisa: { required },
  },
}

export const validateComputed = {
    pesquisasErrors() {
    const errors = []
    if (!this.$v.form.pesquisas.$dirty) return errors
    !this.$v.form.pesquisas.required && errors.push('Campo obrigatório.')
    !this.$v.form.pesquisas.minLength && errors.push('Campo obrigatório.')
    return errors
  }
 
}
